export default {
  title: {
    id: 'swap_confirmation_title',
    defaultMessage: 'Hurray, we found a buyback offer for your {device}',
  },
  priceHint: {
    id: 'swap_confirmation_price_hint',
    defaultMessage: 'Refunded after your buy',
  },
  buyNow: {
    id: 'swap_confirmation_buy_now',
    defaultMessage: 'Buy now',
  },
  buyDetails: {
    id: 'swap_confirmation_buy_details',
    defaultMessage: '{product} at {price} (+ {delivery} delivery)',
  },
  buyDetailsWithoutDelivery: {
    id: 'swap_confirmation_buy_details_without_delivery',
    defaultMessage: '{product} at {price}',
  },
  accept: {
    id: 'swap_confirmation_button_yes',
    defaultMessage: 'Accept',
  },
  refuse: {
    id: 'swap_confirmation_button_no',
    defaultMessage: 'No thanks',
  },
}
